<template>
    <div class="form-group mod">
        <label :for="id" class="form-label" :class="{ require: required }" v-if="title">
            {{ title }}
        </label>
        <div class="input-group remove-padding mod">
            <div v-if="prefixLeft" class="input-group-prepend">
                <span class="input-group-text">{{ prefix }}</span>
            </div>
            <input
                type="tel"
                class="form-control"
                :placeholder="placeholder"
                :autocomplete="isOnAutocomplete"
                :disabled="disable"
                :id="id"
                v-model="nominal.formatted"
                @blur="focusOut(nominal.formatted)"
                @focus="$emit('focus')"
            />
            <div v-if="prefixRight" class="input-group-prepend">
                <span class="input-group-text">{{ prefix }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SOInputNominal",
    props: {
        title: String,
        id: String,
        placeholder: String,
        required: Boolean,
        defaultValue: String,
        maxValue: String,
        disable: Boolean,

        prefix: String,
        prefixRight: Boolean,
        prefixLeft: Boolean,
        useComma: Boolean,
        isPercent: Boolean,
        useAutocomplete: {
            type: Boolean,
            default: true,
        },
        allowZero: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            nominal: {
                formatted: "",
                raw: 0,
            },
            defaultValueCalled: false,
        };
    },
    mounted() {
        if (this.defaultValue !== undefined) {
            this.formattingNominal(this.defaultValue);
        }
        $(".for-tooltip").tooltip({ title: "Hooray!", trigger: "click", selector: ".has-tooltip" });
    },
    watch: {
        "nominal.formatted": {
            handler: function(v) {
                this.formattingNominal(v);
            },
        },
        defaultValue: {
            handler: function(v) {
                this.formattingNominal(v);
            },
        },
        value: {
            handler: function(v) {
                if (!this.defaultValueCalled) {
                    this.formattingNominal(v);
                    this.defaultValueCalled = true;
                }
            },
        },
        defaultValue: {
            handler: function(v) {
                this.formattingNominal(v);
            },
        },
    },
    computed: {
      isOnAutocomplete: function() {
        return this.useAutocomplete ? "on" : "off";
      }
    },
    methods: {
        beforeFormatting(value) {
            // cek kosong
            if (value === "") {
                this.nominal.formatted = "";
                this.nominal.raw = 0;
                this.$emit("input", this.nominal);
                return false;
            }

            // cek 0
            if (value === "0" && !this.isPercent && !this.useComma) {
                this.nominal.formatted = this.allowZero ? "0" : "";
                this.nominal.raw = 0;
                this.$emit("input", this.nominal);
                return false;
            }

            // after 0
            if (value.length > 1 && value.substr(0, 1) === "0" && value.substr(1, 1) !== ",") {
                this.nominal.formatted = value.substr(1, 1);
                this.nominal.raw = Number(value.substr(1, 1));
                this.$emit("input", this.nominal);
                return false;
            }

            // koma
            if (value.includes(",") && value.length === 1) {
                this.nominal.formatted = "0,";
                this.nominal.raw = 0;
                this.$emit("input", this.nominal);
                return false;
            }

            // limit 100%
            if (this.isPercent && this.getNominalRaw(value) >= 100) {
                this.nominal = {
                    formatted: "100",
                    raw: 100,
                };
                this.$emit("input", this.nominal);
                return false;
            }

            // limit max value
            if (this.maxValue !== undefined) {
                if (this.getNominalRaw(value) > this.getNominalRaw(this.maxValue)) {
                    this.nominal.formatted = this.getNominalFormatted(this.maxValue);
                    this.nominal.raw = this.getNominalRaw(this.maxValue);
                    this.$emit("input", this.nominal);
                    return false;
                }
            }

            return true;
        },
        regexingNominal(value) {
            var nominalRegex;
            if (this.useComma !== undefined) {
                if (!this.useComma) {
                    nominalRegex = value.replace(/[^0-9]+/g, "");
                } else {
                    nominalRegex = value.replace(/[^0-9,]+/g, "");
                }
            } else {
                nominalRegex = value.replace(/[^0-9,]+/g, "");
            }
            return nominalRegex;
        },
        formattingNominal(value) {
            if (!this.beforeFormatting(value)) {
                return;
            }
            // format nominal
            this.nominal.formatted = this.getNominalFormatted(value);
            this.nominal.raw = this.getNominalRaw(value);
            this.$emit("input", this.nominal);
        },
        getNominalFormatted(value) {
            var angka = this.regexingNominal(value);

            var split = angka.split(",");
            var sisa = split[0].length % 3;
            var rupiah = split[0].substr(0, sisa);
            var ribuan = split[0].substr(sisa).match(/\d{3}/gi);
            if (ribuan) {
                var separator = sisa ? "." : "";
                rupiah += separator + ribuan.join(".");
            }

            return (rupiah = split[1] !== undefined ? rupiah + "," + split[1].substr(0, 3) : rupiah);
        },
        getNominalRaw(value) {
            value = this.regexingNominal(value);

            var nominalRaw = parseFloat(value.replace(",", "."));
            if (isNaN(nominalRaw)) {
                nominalRaw = 0;
            }
            return nominalRaw;
        },

        // event
        focusOut(value) {
            if (value.includes(",") && value.split(",")[1].length === 0) {
                value = value.replace(",", "");
                this.nominal.formatted = value;
                this.nominal.raw = this.getNominalRaw(value);
                this.$emit("input", this.nominal);
            }
        },
    },
};
</script>